<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-3">
                            <label
                                ><label style="color: red; height: 2px;">*</label> از تاریخ</label
                            >
                            <Datepicker
                                simple
                                auto-submit
                                id="from-date"
                                locale="fa"
                                input-format="YYYY-MM-DD"
                                :max="today"
                                v-model="fromDate"
                                :locale-config="{
                                    fa: {
                                        displayFormat: 'jYYYY/jMM/jDD',
                                        lang: { label: 'شمسی' }
                                    }
                                }"
                            />
                        </div>
                        <div class="col-md-3">
                            <label
                                ><label style="color: red; height: 2px;">*</label> تا تاریخ</label
                            >
                            <Datepicker
                                simple
                                auto-submit
                                id="to-date"
                                locale="fa"
                                input-format="YYYY-MM-DD"
                                :max="today"
                                v-model="toDate"
                                :locale-config="{
                                    fa: {
                                        displayFormat: 'jYYYY/jMM/jDD',
                                        lang: { label: 'شمسی' }
                                    }
                                }"
                            />
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>نوع مدرک</label>
                                <select class="form-control" v-model="documentType">
                                    <option value="" selected>هیچ کدام</option>
                                    <option
                                        v-for="(documnet, index) in documentList"
                                        :value="documnet.id"
                                        :key="index"
                                        >{{ documnet.documentName }}</option
                                    >
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="display: flex; justify-content: end">
                        <div class="col-md-3">
                            <button
                                class="btn btn-primary w-100"
                                style="margin-top:29px"
                                @click="handleSearch"
                                :disabled="fromDate == '' || toDate == ''"
                            >
                                <i class="si si-magnifier"></i>
                                جستجو
                            </button>
                        </div>
                    </div>
                    <hr />
                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>نام و نام خانوادگی</th>
                                <th>وضعیت</th>
                                <th>کد ملی</th>
                                <th>نوع مدرک</th>
                                <th>کد پستی</th>
                                <th>شماره همراه</th>
                                <th>شهر</th>
                                <th>آدرس</th>
                                <th>زمان درخواست</th>
                                <th>تغییر وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(request, index) in rows" :key="index">
                                <td>{{ index }}</td>
                                <td>{{ request.fullName }}</td>
                                <td>
                                    <span class="badge badge-primay" v-if="request.status == 0"
                                        >ایجاد شده</span
                                    >
                                    <span class="badge badge-info" v-if="request.status == 1"
                                        >آماده ی ارسال</span
                                    >
                                    <span class="badge badge-secondary" v-if="request.status == 2">
                                        ارسال شده</span
                                    >
                                    <span class="badge badge-success" v-if="request.status == 3">
                                        تحویل داده شده</span
                                    >
                                    <span class="badge badge-danger" v-if="request.status == 4">
                                        مرجوع شده</span
                                    >
                                </td>
                                <td>{{ request.nationalCode }}</td>
                                <td>{{ request.document }}</td>
                                <td>{{ request.postalCode }}</td>
                                <td>{{ request.mobile }}</td>
                                <td>{{ request.cityName }}</td>
                                <td>{{ request.address }}</td>
                                <td>
                                    {{
                                        request.requestDate.replace(/\//g, "").slice(0, 4) +
                                            "/" +
                                            request.requestDate.replace(/\//g, "").slice(4, 6) +
                                            "/" +
                                            request.requestDate.replace(/\//g, "").slice(6, 8)
                                    }}
                                </td>
                                <td>
                                    <button
                                        @click="changeStatus(request.id, 'ChangeLogisticToReady')"
                                        class="btn btn-info m-2"
                                    >
                                        آماده شده
                                    </button>
                                    <button
                                        @click="changeStatus(request.id, 'ChangeLogisticToSend')"
                                        class="btn btn-secondary m-2"
                                    >
                                        ارسال شده
                                    </button>
                                    <button
                                        @click="
                                            changeStatus(request.id, 'ChangeLogisticToReturned')
                                        "
                                        class="btn btn-danger m-2"
                                    >
                                        مرجوع شده
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
                <div class="col-12" style="overflow-x: auto;">
                    <ul class="pagination pagination-circled">
                        <li class="page-item" v-if="currentPage > 1">
                            <a class="page-link" href="#" v-on:click="currentPage--"
                                ><i class="icon ion-ios-arrow-forward"></i
                            ></a>
                        </li>
                        <li
                            :class="currentPage == page ? 'page-item active' : 'page-item'"
                            v-for="(page, index) in pages"
                            :key="index"
                        >
                            <div style="display: flex; flex-direction: row;">
                                <span class="page-link ml-1" v-if="page > pages[index - 1] + 1">
                                    ...
                                </span>
                                <a class="page-link" href="#" v-on:click="currentPage = page">{{
                                    page
                                }}</a>
                            </div>
                        </li>
                        <li class="page-item" v-if="pages.length != currentPage">
                            <a class="page-link" href="#" v-on:click="currentPage++"
                                ><i class="icon ion-ios-arrow-back"></i
                            ></a>
                        </li>
                    </ul>
                </div>
            </div>
            <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
        </div>
    </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
    name: "Logistic",
    data() {
        return {
            showLoading: false,
            documentType: "",
            documentList: [],
            rows: [],
            currentPage: 1,
            pages: [1],
            perPage: 10,
            count: 0,
            today: moment().format("jYYYY-jMM-jDD"),
            fromDate: moment()
                .add(-1, "month")
                .format("jYYYY/jMM/jDD"),
            toDate: moment().format("jYYYY/jMM/jDD")
        };
    },
    methods: {
        getData() {
            this.showLoading = true;
            this.$api.get("Logistic/GetLogisticDocuments").then(({ data }) => {
                if (data.status) this.documentList = data.result;
                this.showLoading = false;
            });
        },
        changeStatus(id, url) {
            this.showLoading = true;
            this.$api
                .post("Logistic/" + url, { logisticRequestId: id })
                .then(({ data }) => {
                    if (data.status) {
                        this.$swal({
                            title: "تبریک",
                            icon: "success",
                            text: "تغییر موقعییت با موفقیت انجام شد."
                        }).then(() => {
                            this.handleSearch();
                        });
                    }
                })
                .catch(() => {
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: "تغییر موقعییت با موفقیت انجام نشد ,لذا مجدد اقدام کنید!"
                    });
                })
                .finally(() => {
                    this.showLoading = false;
                    if (dialog) {
                        dialog.close();
                    }
                });
        },
        handlePaginateArray(pagesCount) {
            let pagesArray = [1];
            if (pagesCount > 1) {
                if (this.currentPage > 2) pagesArray.push(this.currentPage - 1);
                if (this.currentPage > 1) pagesArray.push(this.currentPage);
                if (this.currentPage < pagesCount) pagesArray.push(this.currentPage + 1);
                const middle = Math.ceil(pagesCount / 2);
                if (middle > this.currentPage + 1 && middle < pagesCount - 2) {
                    pagesArray.push(middle);
                }
                if (this.currentPage < pagesCount) pagesArray.push(pagesCount);
            }
            this.pages = pagesArray;
        },
        handleSearch() {
            const postData = {
                page: 0,
                perPage: 10,
                fromDate: this.fromDate.replace(/\//g, ""),
                toDate: this.toDate.replace(/\//g, ""),
                documentType: this.documentType
            };
            this.showLoading = true;
            this.$api.post("Logistic/GetLogisticRequestList", postData).then(({ data }) => {
                if (data.status) {
                    this.rows = data.result.list;
                    this.count = data.result.totalCount;
                    let calcPages = Math.ceil(data.result.totalCount / this.perPage);
                    this.handlePaginateArray(calcPages);
                }
                this.showLoading = false;
            });
        }
    },
    created() {
        this.getData();
        this.handleSearch();
    }
};
</script>
